import { v4 as uuid } from 'uuid';
import { encounterIdA } from '../encounters';
import { Order, OrderType } from '@getvim-os/types';
import { mickAbae } from '../providers';

export const orderG: Order = {
  id: uuid(),
  type: OrderType.DI,
  icd: [
    {
      name: 'Essential hypertension',
      code: 'I10',
    },
  ],
  cpts: [
    {
      name: 'CT scan of abdomen with contrast',
      code: '74160',
    },
    {
      name: 'X-ray chest 2 views',
      code: '71046',
    },
  ],
  encounterId: encounterIdA,
  createdDate: '2024-01-15',
  orderingProvider: mickAbae,
  basicInformation: {
    notes: 'Patient presents with abdominal pain. Ordered CT scan to rule out appendicitis.',
    orderName: 'Abdominal CT with Contrast',
  },
  targetProvider: {
    providerEhrId: 'RAD-12345',
    npi: '1234567890',
    type: 'FACILITY',
    specialty: [
      {
        description: 'Diagnostic Radiology',
      },
    ],
    degree: 'MD',
  },
};
